import { Group, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import type { UseFilterReturn } from '../hooks/useFilter';
import { BranchSelector } from './BranchSelector';
import { DateRangePicker } from './DateRangePicker';

interface PageHeaderProps {
	title: string | ReactNode;
	filter?: UseFilterReturn;
	hideFiltering?: boolean;
	children?: ReactNode;
	rightContent?: ReactNode;
	icon?: ReactNode;
	isCentered?: boolean;
	filterOnSameLine?: boolean;
	variant?: 'default' | 'filled' | 'unstyled' | 'borderless-filled';
}

export function PageHeader({
	title,
	filter,
	hideFiltering = false,
	children,
	rightContent,
	icon,
	isCentered = false,
	variant = 'borderless-filled',
}: PageHeaderProps) {
	return (
		<>
			<Group justify={isCentered ? 'center' : 'space-between'} w={'100%'}>
				<Group>
					<Title id={'page-title'} fw={600} order={2}>
						{title}
					</Title>
					{icon && <>{icon}</>}
				</Group>
				{hideFiltering && <>{children ?? <>{children}</>}</>}
				{/* biome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation> */}
				{!hideFiltering && !children && (
					<Group>
						{children ?? <>{children}</>}
						<>
							{/* biome-ignore lint/style/noNonNullAssertion: <explanation> */}
							<BranchSelector filter={filter!} variant={variant} />
							{/* biome-ignore lint/style/noNonNullAssertion: <explanation> */}
							<DateRangePicker filter={filter!} variant={variant} />
						</>
						{rightContent ?? <>{rightContent}</>}
					</Group>
				)}
			</Group>

			{children && !hideFiltering && (
				<Group justify="space-between" w={'100%'}>
					<Group>{children ?? <>{children}</>}</Group>
					<Group>
						{
							<>
								{/* biome-ignore lint/style/noNonNullAssertion: <explanation> */}
								<BranchSelector filter={filter!} variant={variant} />
								{/* biome-ignore lint/style/noNonNullAssertion: <explanation> */}
								<DateRangePicker filter={filter!} variant={variant} />
							</>
						}
						{rightContent ?? <>{rightContent}</>}
					</Group>
				</Group>
			)}
		</>
	);
}
